<template>
	<v-overlay v-if="loading" opacity="1" color="secondary">
		<v-progress-circular indeterminate size="128" color="primary"></v-progress-circular>
	</v-overlay>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean
		}
	}
};
</script>